/**
 * Handle OTP input change with support for paste events
 * Returns the updated code array and the index to focus next
 */
export const handleOTPInputChange = (
  index: number,
  value: string,
  currentCode: string[]
): { newCode: string[]; nextFocusIndex: number | null } => {
  const newCode = [...currentCode];

  // Handle paste event (multiple digits)
  if (value.length > 1) {
    const digits = value.replace(/\D/g, '').slice(0, 6).split('');
    let currentIndex = index;

    for (const digit of digits) {
      if (currentIndex < currentCode.length) {
        newCode[currentIndex] = digit;
        currentIndex++;
      }
    }

    // Focus last filled field
    const nextFocusIndex = Math.min(currentIndex, currentCode.length - 1);
    return { newCode, nextFocusIndex };
  }

  // Handle single digit input
  if (value.length === 1) {
    newCode[index] = value;
    const nextFocusIndex = index < currentCode.length - 1 ? index + 1 : null;
    return { newCode, nextFocusIndex };
  }

  // Handle backspace (empty value)
  newCode[index] = '';
  return { newCode, nextFocusIndex: null };
};
